export const getOptions = (data) => {
    const options = {
        series: data,
        tooltip: {
          enabled: false,
        },
        chart: {
            animations: {
              enabled: false,
            },
            height: 127,
            width: '100%',
            type: 'bar',
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                columnWidth: 25,
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        colors: ["#9BC225"],
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return val;
            },
            offsetY: -20,
            style: {
                fontSize: '6px',
                colors: ["#9BC225"]
            }
        },

        xaxis: {
            position: 'top',
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            },
            labels: {
                show: false
            }
        },

        yaxis: {
            labels: {
                align: 'right',
                style: {
                    colors: ["#727984"],
                    fontSize: '6px',
                    marginBottom: '9px',
                    fontFamily: 'Helvetica, Arial, sans-serif',
                    fontWeight: 400,
                    cssClass: 'apexcharts-yaxis-label',
                },
            },
        }
    };

    return options
}

export const getAreaOptions = (data, color = '#577590', showX = false) => {
    const options = {
        series: [{
            data: data
        }],
        tooltip: {
          enabled: false,
        },
        chart: {
            animations: {
              enabled: false,
            },
            type: 'area',
            height: 102,
            width: '100%',
            toolbar: {
                show: false,
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'stepline',
            colors: [color],
            width: 1
        },
        fill: {
            colors: [color]
        },
        xaxis: {
            position: 'top',
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            },
            labels: {
                show: showX,
                offsetY: -3.5,
                align: 'right',
                style: {
                    fontSize: '6px',
                    marginBottom: '9px',
                    fontFamily: 'Helvetica, Arial, sans-serif',
                    fontWeight: 400,
                    cssClass: 'apexcharts-xaxis-label',
                },
            }
        },
        yaxis: {
            labels: {
                align: 'right',
                style: {
                    colors: ["#727984"],
                    fontSize: '6px',
                    marginBottom: '9px',
                    fontFamily: 'Helvetica, Arial, sans-serif',
                    fontWeight: 400,
                    cssClass: 'apexcharts-yaxis-label',
                },
            },
        },
    };

    return  options
}

export default getAreaOptions()
